import Axios from "axios";
import { baseURL } from "../../configurations/environment";
import { RequestConfig } from "../RequestConfig";

/**
 * Validates OneLink URL for Adjust platform
 * @param {string} onelink - The OneLink URL to validate
 * @param {string} platform - The MMP platform (e.g., "adjust", "appsflyer")
 * @returns {Promise<Object>} Validation result with status and data
 */
export const validateOneLink = async (onelink, platform) => {
    try {
        const response = await Axios.post(
            `${baseURL}/api/landing/check-onelink`,
            {
                onelink,
                platform,
            },
            RequestConfig()
        );
        
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        if (error?.response?.data) {
            return {
                success: false,
                data: error.response.data,
            };
        }
        return {
            success: false,
            data: {
                status: false,
                message: "An error occurred while validating OneLink",
                data: [],
            },
        };
    }
};

